import React from "react";
import { Button } from "@material-ui/core";
import { Field, Formik } from "formik";
import { Dialog } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { getUserProfile, updateUserInfo } from "../CrudAndRedux/ProfileCrud";
import { Input } from "../../../../_metronic/_partials/controls";
import { actions as authActions } from "../../Auth/_redux/authRedux";
import { toast } from "react-toastify";
import { useMediaQuery } from "react-responsive";


const EmailAndPhone = (props) => {
  const [open, setOpen] = React.useState(false);
  const [isEmail, setIsEmail] = React.useState(false);

  const { state: authState } = useSelector((state) => ({
    state: state.auth,
  }));


  const dispatch = useDispatch();
  const InputValue = React.useRef();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const isMobile = useMediaQuery({ query: `(max-width: 760px)` });

  return (
    <div className="d-block d-md-flex my-10 container justify-content-between px-0">
      {!authState.user ? null : (
        <>
          <div className="col-12 col-md-6 p-1">
            <div
              style={{ border: "1px solid lightgray", borderRadius: 13 }}
              className="bg-white row flex-column h-100 shadow-sm p-5 mt-3 text-right w-100 mx-auto"
            >
              <div className="d-flex justify-content-between justify-content-md-start align-items-baseline">
                <h2 className="my-5" style={{ fontSize: "20px" }}>
                  <b> ایمیل</b>
                </h2>
                <span
                  className="ml-5"
                  style={{ color: "#6dd06d", cursor: "pointer", fontSize: 15 }}
                  onClick={() => {
                    handleClickOpen();
                    setIsEmail(true);
                  }}
                >
                  <i className="fa fa-edit" style={{ color: "#6dd06d" }}>
                    {" "}
                  </i>
                  <span>
                    <b> ویرایش</b>
                  </span>
                </span>
              </div>
              <h6 className="my-5 font-16">
                {" "}
                {authState.user.user.email
                  ? authState.user.user.email
                  : "موجود نیست!"}
              </h6>
            </div>
          </div>
          <div className="col-12 col-md-6 p-1">
            <div
              style={{ border: "1px solid lightgray", borderRadius: 13 }}
              className="bg-white row flex-column h-100 shadow-sm  p-5 mt-3 text-right w-100 mx-auto justify-content-around"
            >
              <div className="d-flex justify-content-between justify-content-md-start align-items-baseline">
                <h2 className="my-5" style={{ fontSize: "20px" }}>
                  <b> شماره موبایل</b>
                </h2>
                <span
                  className="ml-5"
                  style={{ color: "#6dd06d", cursor: "pointer", fontSize: 15 }}
                  onClick={() => {
                    handleClickOpen();
                    setIsEmail(false);
                  }}
                >
                  <i className="fa fa-edit" style={{ color: "#6dd06d" }}>
                    {" "}
                  </i>
                  <span>
                    <b> ویرایش</b>
                  </span>
                </span>
              </div>
              <h6 className="my-5 font-16">
                {" "}
                {authState.user.user.phone
                  ? authState.user.user.phone
                  : "موجود نیست!"}
              </h6>
            </div>
          </div>
        </>
      )}
      <Dialog
        open={open}
        keepMounted
        onClose={handleClose}
        className="p-5"
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          style: {
            width: "45rem",
            height: "fit-content",
          },
        }}
        fullScreen={isMobile ? true : false}
      >
        <div style={{ padding: 30 }}>
          <Formik
            enableReinitialize
            onSubmit={(values) => {
              handleClose();
              updateUserInfo(values, authState.user.token)
                .then((res) => {
                  toast.success(
                    <span style={{ fontFamily: "sans" }}>
                      اطلاعات با موفقیت تغییر یافت
                    </span>
                  );
                  getUserProfile(authState.user.token).then((res) => {
                    dispatch(authActions.setUserInfo(res.data.data));

                  });
                })
                .catch((err) => {
                  toast.error(
                    <span style={{ fontFamily: "sans" }}>
                      مشکلی در ارتباط با سرور بوجود آمد
                    </span>
                  );
                });
            }}
            initialValues={authState.user ? authState.user.user : {}}
          >
            {({ handleSubmit }) => {
              return (
                <>
                  <div className="row  mb-7">
                    <h2 className="my-3">
                      ویرایش {isEmail ? "ایمیل" : "تلفن همراه"}
                    </h2>
                  </div>
                  {isEmail ? (
                    <div className="row mb-7">
                      <div className="col-12" style={{ height: "4rem" }}>
                        <Field
                          name="email"
                          placeholder="ایمیل"
                          onKeyUp={(e) => {
                            if (e.which === 13) {
                              handleSubmit();
                            }
                          }}
                          className="w-100 h-100 px-4 text-center fields-inputs"
                          component={Input}
                          ref={InputValue}
                        />
                      </div>
                    </div>
                  ) : (
                    <div className="row mb-7">
                      <div className="col-12" style={{ height: "4rem" }}>
                        <Field
                          name="phone"
                          placeholder="تلفن همراه"
                          onKeyUp={(e) => {
                            if (e.which === 13) {
                              handleSubmit();
                            }
                          }}
                          className="w-100 h-100 px-4 text-center fields-inputs"
                          component={Input}
                          ref={InputValue}
                        />
                      </div>
                    </div>
                  )}
                  <div
                    className="row mt-5"
                    style={{ justifyContent: "center" }}
                  >
                    <div
                      className="col-12 col-md-6 my-2"
                      style={{ height: "4rem" }}
                    >
                      <Button
                        style={{
                          border: "1px solid #D9D9D9",
                          color: "white",
                          backgroundColor: "lightgray",
                          borderRadius: 13,
                        }}
                        onClick={() => handleClose()}
                        className="h-100 w-100"
                      >
                        <h6 className="mx-auto my-auto text-white">انصراف</h6>
                      </Button>
                    </div>
                    <div
                      className="col-12 col-md-6 my-2"
                      style={{ height: "4rem" }}
                    >
                      <Button
                        className="h-100 w-100"
                        style={{
                          backgroundColor: "#6dd06d",
                          border: "1px solid #6dd06d",
                          borderRadius: 12,
                        }}
                        onClick={() => {
                          handleSubmit();
                          handleClose();
                        }}
                      >
                        <h6 className="mx-auto my-auto text-white">ثبت</h6>
                      </Button>
                    </div>
                  </div>
                </>
              );
            }}
          </Formik>
        </div>
      </Dialog>
    </div>
  );
};

export default EmailAndPhone;
